<template>
  <div class="funds-list page-box">
    <query-header
      ref="header"
      @toQuery="sourceType = $event; toQuery()"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input header-item"
          v-model="login"
          :placeholder="$t('transaction_account')"
          clearable
        ></el-input>
        <el-input
          v-if="sourceType !== 3"
          class="search-input symbol header-item"
          v-model="belongCustomerInfo"
          clearable
          :placeholder="$t('Attributed_Customer_IB')"
        ></el-input>
        <vs-button
          class="search-btn header-item"
          @click="searchHandle"
        >{{$t('search')}}</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead">
            <vs-th>
              {{$t('Trade.orderNo')}}
            </vs-th>
            <vs-th>
              {{$t('transaction_account')}}
            </vs-th>
            <vs-th>
              {{$t('Source_of_rebate')}}
            </vs-th>
            <vs-th>
              {{$t('Attributed_Customer_IB')}}
            </vs-th>
            <vs-th>
              {{$t('inner_commission')}}(USD)
            </vs-th>
            <vs-th>
              {{$t('outside_commission')}}(USD)
            </vs-th>
            <vs-th>
              {{$t('total_commission')}}(USD)
            </vs-th>
            <vs-th
            >
              {{$t('User.reportCloseTime')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr style="background-color:#F3F2F7;">
              <vs-td>
                {{$t('total')}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{statistics.inCommissionSum}}
              </vs-td>
              <vs-td>
                {{statistics.outCommissionSum}}
              </vs-td>
              <vs-td>
                {{statistics.commissionSum}}
              </vs-td>
              <vs-td class="">
                {{'-'}}
              </vs-td>
            </vs-tr>
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.order}}
              </vs-td>

              <vs-td>
                {{tr.login}}
              </vs-td>
              <vs-td>
                <!--来源-->
                {{getSource(tr)}}
              </vs-td>
              <vs-td>
                <div>{{tr.belongName}}</div>
                <div>{{tr.belongId}}</div>
              </vs-td>
              <vs-td>
                {{tr.inCommission || '-'}}
              </vs-td>
              <vs-td>
                {{tr.outCommission}}
              </vs-td>
              <vs-td>
                {{tr.commission}}
              </vs-td>
              <vs-td
              >
                {{parseTime(tr.closeTime)}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime,getIsMoreThreeMonth } from '@/utils/index';

// 表格字段需要重新调
import initData from "@/mixins/initData";
import queryHeader from "@/components/agent/commissionManage/comissionRecord/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      statistics: {
        inCommissionSum: 0,
        commissionSum: 0,
        outCommissionSum: 0
      },
      login: '',
      sourceType: '',
      belongCustomerInfo: '',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/partner/commStat';
      this.params = {
        page: this.page - 1,
        size: this.size,
        custId: this.userInfo.id,
      }
      let header = this.$refs.header;
      // 添加时间
      if(header.type){
        this.params.sourceType = header.type;
      }
      if(this.login){
        this.params.login = +this.login;
      }
      if(header.type !== 3 && this.belongCustomerInfo){
        this.params.sourceInfo = this.belongCustomerInfo;
      }

      if(header.date && header.date.length){
        if(getIsMoreThreeMonth(header.date[0],header.date[1])){
          this.$message({
            type: 'error',
            message: this.$t('A_maximum_of_three_months_can_be_queried')
          })
          return false;
        }else {
          this.params.startTime = header.date[0];
          this.params.endTime = header.date[1];
        }
      }
      return true;
    },
    getSystem(item){
      switch (item.systerm){
        case 1:
          return 'MT4';
        case 2:
          return 'MT5';
        case 3:
          return 'CTRade';
      }
    },
    getSource(item){
      if(item.belongId == this.userInfo.id) return this.$t('Myself');
      return item.ibRank > 0 ? this.$t('sub_IB') : this.$t('Straight_off');
    },

    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.search-input {
  margin-left: 5px;
  margin-right: 5px;
}
.header-item {
  margin-bottom: 10px;
}
</style>
